import { FC, useEffect, useRef } from 'react';
import { useFormContext } from 'react-hook-form';
import useValidateVisibleCondition from '../../../../hooks/useValidateVisibleCondition';
import {
  AnswerApplicationQuestionRequest,
  FieldObject,
} from '../../../../openapi/atlantis';
import ConfigDrivenFormInputV2 from './ConfigDrivenFormInputV2';

interface ConfigDrivenConditionalFormInputV2Props {
  name?: string;
  questionAlias?: string;
  checklistItemId: string;
  isSubmitting: boolean;
  field: FieldObject;
  onSubmit: (e: AnswerApplicationQuestionRequest) => void;
  onNavigateToQuestion?: (questionId: string) => Promise<void>;
}

const ConfigDrivenConditionalFormInputV2: FC<
  ConfigDrivenConditionalFormInputV2Props
> = ({
  name,
  questionAlias,
  checklistItemId,
  isSubmitting,
  field,
  onSubmit,
  onNavigateToQuestion,
}) => {
  const { validateFieldVisibleCondition } = useValidateVisibleCondition();
  const isVisible = validateFieldVisibleCondition(field);
  const { resetField } = useFormContext();
  const prevVisibleRef = useRef(isVisible);

  useEffect(() => {
    // Clear field value when it becomes hidden
    if (prevVisibleRef.current && !isVisible && name) {
      resetField(name, { defaultValue: null });
    }
    prevVisibleRef.current = isVisible;
  }, [isVisible, name, resetField]);

  if (!isVisible) {
    return null;
  }

  return (
    <div className='mb-4'>
      <ConfigDrivenFormInputV2
        name={name!}
        field={field}
        questionAlias={questionAlias}
        onSubmit={onSubmit}
        isSubmitting={isSubmitting}
        checklistItemId={checklistItemId}
        onNavigateToQuestion={onNavigateToQuestion}
      />
    </div>
  );
};
export default ConfigDrivenConditionalFormInputV2;
